import moment from "moment";
import isEmpty from "lodash/isEmpty";
import { $integrations, $connectorApp } from "@/services";

/**
 * Integrations functionality mixin
 * @description Add common attributed related to integration functionality
 * @author {Jatin Kamboj}
 */
export default {
  name: "IntegrationsMixin",
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      /**
       * Name of the drawer to be opened and closed
       * @description Define this drawerName in parent component with drawer component name as a value
       * @example drawerName: [DRAWER_COMPONENT_NAME]  // In parent component
       */
      drawerName: "",
      isConnecting: false
    };
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  computed: {
    isFirstConnection() {
      return this.$store.getters["ui/drawer"].right.firstConnection;
    },
    /**
     * Determines whether store need to be updated or not
     */
    isEditStore() {
      return this.$store.getters["ui/drawer"].right.editStore;
    }
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    underscoreRemover(value) {
      return this.$options.filters.underscoreRemover(value);
    },
    /**
     * Toogles drawer and allows to add a store a in integration view
     */
    addStore(data = { firstConnection: false }) {
      const drawer = this.$store.getters["ui/drawer"].right;
      this.$store.commit("ui/drawer.right", {
        component: this.drawerName,
        show: !drawer.show,
        width: "700px",
        firstConnection: true,
        editStore: false,
        ...data
      });
    },
    /**
     * Toogles drawer and allows user to edit alreday added store in integration view
     */
    editStoreDrawer(id, type = null, data = {}) {
      const drawer = this.$store.getters["ui/drawer"].right;
      this.$store.commit("ui/drawer.right", {
        component: this.drawerName,
        show: !drawer.show,
        width: "700px",
        firstConnection: false,
        editStore: true,
        storeId: id,
        integrationType: type,
        ...data
      });
    },
    checkConnectorAppToken(payload) {
      this.isConnecting = true;
      if (
        Object.keys(this.$store.getters["auth/connectorAppData"]).length > 0
      ) {
        const currentTime = new Date().getTime();
        const generatedTokenTime = new Date(
          this.$store.getters["auth/connectorAppData"].generationTime
        ).getTime();
        const timeElapsed = (currentTime - generatedTokenTime) / 1000;
        const expiresInTime = this.$store.getters["auth/connectorAppData"]
          .expire;
        if (timeElapsed < expiresInTime) {
          this.makeStoreConnection(payload);
        } else {
          this.generateConnectorAuthToken();
        }
      } else {
        this.generateConnectorAuthToken();
      }
    },
    /**
     * Send http request to the server to generate a new Jwt token
     * which will be used to suthorise htto request from client side
     */
    async generateConnectorAuthToken(checkConnection = true) {
      try {
        const res = await $integrations.getConnectorAuthToken();
        const data = res.data;
        data.generationTime = new Date();

        this.$store.commit("auth/connectorAppData", data);
        checkConnection && this.checkConnectorAppToken();
      } catch (error) {
        this.showErrorMessage(error);
      }
    },
    /**
     * Regenerates auth token if jwt stored on store token is expired
     */
    async regenrateToken() {
      if (!isEmpty(this.$store.getters["auth/connectorAppData"])) {
        let { generationTime } = this.$store.getters["auth/connectorAppData"];
        generationTime = moment(generationTime);

        const currentTime = moment(new Date());
        const isTokenExpired = currentTime.isAfter(generationTime, "seconds");

        if (isTokenExpired) {
          await this.generateConnectorAuthToken(false);
        }
      } else {
        await this.generateConnectorAuthToken(false);
      }
    },
    makeStoreConnection(payload) {
      $connectorApp
        .createStoreConnection("keap", payload)
        .then(res => {
          window.location.href = res.data.redirect_url;
        })
        .catch(errors => {
          let msg = "";
          Object.keys(errors.response.data.errors).forEach(key => {
            msg = `${key} ${errors.response.data.errors[key]}`;
          });
          store.commit("ui/snackbar", {
            message: msg.replace("_", " "),
            type: "error"
          });
        })
        .finally(() => {
          this.isConnecting = false;
        });
    },
    /**
     * Generic api error message handler
     */
    showErrorMessage(error) {
      const { firstCharCapital } = this.$options.filters;
      let message = error.message || "Something went wrong.";

      if (error && error.response && error.response.data) {
        const { data } = error.response;
        message = Object.keys(data).reduce(
          (acc, curr) =>
            acc.concat(`${firstCharCapital(curr)} ${data[curr]}`, " "),
          ""
        );
      }

      this.$store.commit("ui/snackbar", { message, type: "error" });
    }
  }
};
